import {Buffer} from 'buffer';
export const convertFirstLetterCapital=(string)=>{

    if(!string)return ""
    return string.charAt(0).toUpperCase() + string.slice(1);

}

// export function hashObjectIdToSixDigits(objectId) {
//     // Basic hash function to generate a 6-digit hash
//     const binaryData = Uint8Array.from(Buffer.from(objectId, 'hex'));
//     const base64Encoded = btoa(String.fromCharCode.apply(null, binaryData));
//     return base64Encoded;
  
//   }
  


// export function hashObjectIdToSixDigits(mongoObjectId){
//     const base64Encoded = objectIdToBase64(mongoObjectId);
//     const decodedObjectId = base64ToObjectID(base64Encoded);

//     return decodedObjectId

// }


export function hashObjectIdToSixDigits(objectId) {
  const binaryData = Uint8Array.from(Buffer.from(objectId, 'hex'));
  let base256Encoded = '';

  for (let i = 0; i < binaryData.length; i++) {
    const byteValue = binaryData[i];
    base256Encoded += String.fromCharCode(byteValue);
  }

  return base256Encoded;
}


export function objectIdToBase64(objectId) {
  const binaryData = Uint8Array.from(Buffer.from(objectId, 'hex'));
  const base64Encoded = btoa(String.fromCharCode.apply(null, binaryData));
  return base64Encoded;
}

function base64ToObjectID(base64Encoded) {
  const binaryString = atob(base64Encoded);
  const binaryData = Uint8Array.from(binaryString, c => c.charCodeAt(0));
  return Buffer.from(binaryData).toString('hex');
}